export const API_URL = "https://dhrutham-notes-backend.herokuapp.com";
export const API_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
